import { useRouter } from 'next/router';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { useDispatch } from 'react-redux';
import useTrans from '../../hooks/useTrans';
import MetaSeo from '../MetaSeo';
// import { getAllServices } from '../../redux/actions/services';

export default function Service(props) {
  // const offshore = {
  //   id: 'offshore',
  //   image: '/assets/images/service/icon-6.svg',
  //   title: 'オフショアサービス',
  //   description: '',
  //   seo_url: 'offshore',
  //   background_image: '/assets/images/service/img-6.jpg',
  // };

  const list_row = [
    ...props.rows,
    // , offshore
  ];
  const dispatch = useDispatch();
  const [rows, setRows] = useState(list_row);
  const [off_fixed, setOffFixed] = useState();
  const [array_ref, setArrayRef] = useState([]);
  const [boxSidebar, setBoxSidebar] = useState(false);
  const router = useRouter();
  const trans = useTrans();

  const changeIndex = index => {
    const newList = [...listActive].map((item, i) => {
      if (i === index) {
        return true;
      }
      return false;
    });

    setListActive(newList);
  };
  rows.map((item, index) => {
    const ref = useRef();
    const [inViewRef, inView] = useInView({
      onChange: inView => {
        if (inView) {
          changeIndex(index);
        }
      },
      threshold: 0.5,
      initialInView: true,
    });
    const setRefs = useCallback(
      node => {
        // Ref's from useRef needs to have the node assigned to `current`
        ref.current = node;
        // Callback refs, like the one from `useInView`, is a function that takes the node as an argument
        inViewRef(node);
      },
      [inViewRef],
    );
    item.index = index;
    item.ref = {
      ref: setRefs,
      inView: inView,
      refNode: ref,
    };
    return item;
  });

  let lastScrollTop = 0;
  // useEffect(() => {
  //
  //   window.scrollTo({ top: 0, behavior: 'smooth' });
  // }, []);
  useEffect(() => {
    // setRows(props.rows);
    window.addEventListener('scroll', onScroll);
  }, [props]);

  const [listActive, setListActive] = useState(
    // rows.map((i, index) => (index === 0 ? null : false)),
    rows.map(i => false),
  );

  const onScroll = e => {
    let a = document.getElementById('footer');
    let b = a.offsetTop;
    let c = e.target.documentElement.scrollTop;
    if (c > b - 1000) {
      setOffFixed('off-fixed');
    } else {
      setOffFixed('');
    }
    // myFun();
  };

  const myFun = () => {
    const listActiveRow = rows.filter(item => item.ref.inView);
    var st = window.pageYOffset || document.documentElement.scrollTop;

    if (listActiveRow.length > 0) {
      if (st > lastScrollTop) {
        changeIndex(listActiveRow[listActiveRow.length - 1].index);
      } else {
        changeIndex(listActiveRow[0].index);
      }
    }
    lastScrollTop = st <= 0 ? 0 : st;
  };

  const onClickActive = async (id, index) => {
    const element = document.getElementById(id);
    if (element) {
      const rect = element.getBoundingClientRect();
      const scrollTop = document.documentElement.scrollTop;
      const absoluteY = scrollTop + rect.top;

      document.documentElement.scrollTo({
        top: absoluteY - 300,
        behavior: 'smooth',
      }) ||
        document.documentElement.scrollTo({
          top: absoluteY - 220,
          behavior: 'smooth',
        });
      // const newList = listActive.map((item, i) => {
      //     if (i === index) {
      //         return true;
      //     } return false;
      // });

      // setListActive(newList);
    }
  };
  const dataSeo = {
    url: process.env.NEXT_PUBLIC_SEO_URL,
    type: 'website',
    title: 'サービス | TCOM JAPAN',
    description:
      'ベトナムの大手オフショア開発会社である TCOM JAPAN は、世界中のあらゆる規模の顧客に強力でスケーラブルで信頼性の高いソフトウェア ソリューションを提供しています。 ',
    domain: process.env.NEXT_PUBLIC_DOMAIN,
    // image: 'https://staging.tcom-japan.com/assets/images/about/gallery-2.png',
    card: 'summary_large_image',
  };

  return (
    <>
      <MetaSeo {...dataSeo} />
      <div className='main-content'>
        <div className={`sidebar ${off_fixed}`}>
          <a class='js-open-sidebar' onClick={() => setBoxSidebar(!boxSidebar)}>
            <svg
              width='41'
              height='31'
              viewBox='0 0 41 31'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <g clip-path='url(#clip0_648_1108)'>
                <path
                  d='M40.2501 4.71724C40.1562 5.00951 40.0831 5.31223 39.9683 5.6045C39.3733 7.05544 38.058 7.89052 36.3461 7.89052C33.1729 7.89052 29.9892 7.89052 26.8159 7.89052C22.6092 7.89052 18.4025 7.89052 14.1958 7.89052C12.4735 7.89052 11.1374 7.03457 10.5528 5.57319C9.61337 3.21411 11.2418 0.698449 13.8201 0.531435C13.9871 0.520996 14.1541 0.520996 14.3315 0.520996C21.628 0.520996 28.914 0.520996 36.2105 0.520996C38.3921 0.520996 39.6864 1.53352 40.2084 3.65252C40.2188 3.6734 40.2397 3.69427 40.2501 3.71515C40.2501 4.03874 40.2501 4.37277 40.2501 4.71724Z'
                  fill='#0063AA'
                />
                <path
                  d='M40.2501 27.2955C40.1458 27.6191 40.0831 27.9531 39.937 28.2558C39.2585 29.7277 38.0789 30.4583 36.4714 30.4897C35.1562 30.5105 33.841 30.4897 32.5257 30.4897C26.4088 30.4897 20.2814 30.4897 14.1645 30.4897C12.2334 30.4897 10.7512 29.3414 10.365 27.546C9.90566 25.4375 11.461 23.3289 13.6113 23.1514C13.8201 23.1306 14.0288 23.1201 14.2376 23.1201C21.5967 23.1201 28.9558 23.1201 36.3044 23.1201C38.1416 23.1201 39.509 24.0387 40.0518 25.6253C40.1249 25.8446 40.1875 26.0638 40.2501 26.2934C40.2501 26.617 40.2501 26.9615 40.2501 27.2955Z'
                  fill='#0063AA'
                />
                <path
                  d='M40.2504 15.9697C40.1878 16.2098 40.1252 16.4499 40.0521 16.6795C39.5302 18.2244 38.1523 19.1847 36.43 19.1847C29.9582 19.1847 23.4863 19.1847 17.0145 19.1847C15.9602 19.1847 14.906 19.2161 13.8517 19.1743C12.3381 19.1117 11.2212 18.3601 10.6158 16.9822C10.0103 15.6044 10.2191 14.2787 11.1899 13.1096C11.9623 12.2015 12.9748 11.8257 14.1648 11.8257C21.5552 11.8361 28.9561 11.8257 36.3465 11.8257C36.3569 11.8257 36.3673 11.8257 36.3882 11.8257C38.3715 11.8361 39.7285 12.9217 40.1878 14.8528C40.1982 14.9154 40.2296 14.9676 40.2504 15.0303C40.2504 15.3434 40.2504 15.6566 40.2504 15.9697Z'
                  fill='#0063AA'
                />
                <path
                  d='M7.60908 15.4793C7.61952 17.5148 5.99113 19.1641 3.95564 19.1745C1.90971 19.1849 0.25 17.5357 0.25 15.4897C0.25 13.4647 1.89927 11.8154 3.92432 11.8154C5.95981 11.8259 7.59864 13.4543 7.60908 15.4793Z'
                  fill='#0063AA'
                />
                <path
                  d='M7.60908 26.7945C7.60908 28.8195 5.98069 30.4688 3.95564 30.4897C1.93058 30.5001 0.25 28.8195 0.25 26.784C0.25 24.7694 1.92015 23.1097 3.93476 23.1202C5.97025 23.1202 7.59864 24.759 7.60908 26.7945Z'
                  fill='#0063AA'
                />
                <path
                  d='M7.60913 4.20575C7.60913 6.24124 5.98074 7.86963 3.94525 7.88007C1.90976 7.89051 0.23961 6.22036 0.250049 4.17443C0.260487 2.15982 1.93063 0.500109 3.94525 0.510547C5.9703 0.520985 7.60913 2.17026 7.60913 4.20575Z'
                  fill='#0063AA'
                />
              </g>
              <defs>
                <clipPath id='clip0_648_1108'>
                  <rect
                    width='40'
                    height='29.9791'
                    fill='white'
                    transform='translate(0.25 0.510498)'
                  />
                </clipPath>
              </defs>
            </svg>
            {trans.layout.service}
          </a>
          <div className={boxSidebar ? 'box open' : 'box'}>
            <h3 className='title'>
              {trans.service.our_service_sub1}
              <br /> {trans.service.our_service_sub2}
            </h3>
            <ul>
              {rows.map((item, index) => {
                return (
                  <li
                    className={listActive[index] ? 'active' : 'non-active'}
                    key={`service_${index}`}
                  >
                    <a onClick={() => onClickActive(item.seo_url, index)}>
                      {item.title}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
        <div className='container'>
          <div className='h1 page-title'>
            {trans.service.our_service_sub}
            {/* {trans.service.our_service_sub1}
            <br /> {trans.service.our_service_sub2} */}
          </div>
        </div>
        <div className='r-service-box'>
          <div className='container'>
            {rows.map((item, index) => {
              return (
                <div
                  id={item.seo_url}
                  ref={item?.ref?.ref}
                  className='box'
                  key={index}
                >
                  <div className='col-info'>
                    <div className='icon'>
                      <img src={item?.image} alt='' />
                    </div>

                    <div className='content'>
                      <h3>{item?.title}</h3>
                      <p>{item?.description}</p>
                      <a
                        ref={item?.ref?.ref}
                        href={
                          // item.seo_url === 'offshore'
                          //   ? '/offshore'
                          //   :
                          `/service/${item.seo_url}`
                        }
                        className='readmore'
                      >
                        {trans.text_button.read_more}
                        <svg
                          width={20}
                          height={20}
                          viewBox='0 0 20 20'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            fillRule='evenodd'
                            clipRule='evenodd'
                            d='M1.25 10.0008C1.25 9.83503 1.31585 9.67606 1.43306 9.55885C1.55027 9.44164 1.70924 9.37579 1.875 9.37579H16.6163L12.6825 5.44329C12.5651 5.32593 12.4992 5.16676 12.4992 5.00079C12.4992 4.83482 12.5651 4.67565 12.6825 4.55829C12.7999 4.44093 12.959 4.375 13.125 4.375C13.291 4.375 13.4501 4.44093 13.5675 4.55829L18.5675 9.55829C18.6257 9.61635 18.6719 9.68532 18.7034 9.76125C18.7349 9.83718 18.7511 9.91858 18.7511 10.0008C18.7511 10.083 18.7349 10.1644 18.7034 10.2403C18.6719 10.3163 18.6257 10.3852 18.5675 10.4433L13.5675 15.4433C13.4501 15.5606 13.291 15.6266 13.125 15.6266C12.959 15.6266 12.7999 15.5606 12.6825 15.4433C12.5651 15.3259 12.4992 15.1668 12.4992 15.0008C12.4992 14.8348 12.5651 14.6756 12.6825 14.5583L16.6163 10.6258H1.875C1.70924 10.6258 1.55027 10.5599 1.43306 10.4427C1.31585 10.3255 1.25 10.1666 1.25 10.0008Z'
                            fill='#0063AA'
                          />
                        </svg>
                      </a>
                    </div>
                  </div>
                  <div className='col-image'>
                    <a
                      ref={item?.ref?.ref}
                      href={
                        // item.seo_url === 'offshore'
                        //   ? '/offshore'
                        //   :
                        `/service/${item.seo_url}`
                      }
                      className='readmore'
                    >
                      <img src={item?.background_image} alt='' />
                    </a>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}
